import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';
import Navbar from '../../components/Navbar';
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs';
import Footer from '../../components/Footer';
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu';
import IndustriesImageContainer from '../../components/IndustriesImageContainer';
import hr_and_payroll_img2 from "../../assets/images/contents/hr-and-payroll-2.gif"
import hr_and_payroll_img1 from "../../assets/images/contents/hr-and-payroll-1.png"
import { PrimaryButton } from '../../components/StyledButtons';
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm';

const HrAndPayroll = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)
    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='hr-and-payroll bg-primary'>
            <div className='color-filter-right' style={{ top: "20%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "52%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid hr-and-payroll-header pb-100'>
                <div className='container'>
                    {language === "en" ?
                        <div className='col-sm-12 pt-150'>
                            <div className='font-weight-bold text-center font-64 hr-and-payroll-header-title'>HR & PAYROLL</div>
                            <div className='col-sm-8 col-sm-offset-2'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                        :
                        <div className='col-sm-12 pt-150'>
                            <div className='font-weight-bold text-center font-64 hr-and-payroll-header-title'>NHÂN SỰ & LƯƠNG BỔNG</div>
                            <div className='col-sm-12'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                    }
                    <div className='col-sm-12 flex justify-center pt-50 px-0'>
                        <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.hr-and-payroll')} linkToPrevPage="/industries" />
                    </div>
                </div>
            </div>
            <div className='hr-and-payroll-content container'>
                <div className='row flex-lg'>
                    <div className='col-lg-w-400'>
                        <IndustriesStickyMenu generalActive={true} hrAndPayrollActive={true} />
                    </div>
                    <div className='col-lg-w--400 hr-and-payroll-content_info'>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <p className='font-48 font-weight-semibold text-white'>{t('hr-and-payroll.title')}</p>
                                <p className='text-white pt-30 font-weight-medium font-20'>{t('hr-and-payroll.sub-title')}</p>
                                <p className='text-white pt-20'>{t('hr-and-payroll.content-1')}</p>
                                <p className='text-white pt-20'>{t('hr-and-payroll.content-2')}</p>
                                <p className='pt-20 text-white'>{t('hr-and-payroll.content-3')}</p>
                                <p className='pt-20 text-white'>{t('hr-and-payroll.content-4')}</p>
                            </div>
                            <div className='col-sm-12'>
                                <div className='pt-50'>
                                    <img src={hr_and_payroll_img1} alt="" className='img-responsive' style={{ borderRadius: "16px" }} />
                                    <div className='arrow-gif'>
                                        <img src={hr_and_payroll_img2} alt="" className='img-responsive' />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12 pt-50'>
                                <p className='text-white font-weight-medium'>{t('hr-and-payroll.content-5')}</p>
                                <ul className='list-unstyled pt-20'>
                                    <li className='checked-line'>{t('hr-and-payroll.content-5-1')}</li>
                                    <li className='checked-line'>{t('hr-and-payroll.content-5-2')}</li>
                                    <li className='checked-line'>{t('hr-and-payroll.content-5-3')}</li>
                                    <li className='checked-line'>{t('hr-and-payroll.content-5-4')}</li>
                                    <li className='checked-line'>{t('hr-and-payroll.content-5-5')}</li>
                                </ul>
                            </div>
                            <div className='col-sm-12 pt-30'>
                                <PrimaryButton
                                onClick={() => setModalDiscussionOpen(true)}
                                >{t('button.schedule-discussion')}</PrimaryButton>
                            </div>
                        </div>
                    </div>
                </div>
                <IndustriesImageContainer />
            </div>
            <Footer />
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
        </div>
    )
}

export default HrAndPayroll